import { MutationTree } from 'vuex';
import { SystemSettingsState } from './types';

export const mutations: MutationTree<SystemSettingsState> = {
  setSystemSettings: (state, data) => {
    state.systemSettings = data;
  },
  setSystemSettingItem: (state, data) => {
    state.systemSettingItem = data;
  }
}